import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import userIcon from '../../assets/icons/iconUser.svg';
import { Download } from '../../controller/FileController';
import { Container } from './styles';
import { useAlert } from '../../hooks/useAlert';
import { useRegisterForm } from '../../context';

interface UserProfilePictureProps {
  pictureId: string | undefined;
  isFeedPicture?: boolean;
}

export function UserProfilePicture({ pictureId, isFeedPicture }: UserProfilePictureProps) {
  const [pictureUrl, setPictureUrl] = useState<string>();
  const { pictureProfile } = useRegisterForm();
  const alert = useAlert();

  useQuery(['picture', pictureId], () => Download(pictureId ?? ''), {
    onSuccess: (response) => {
      if (response) setPictureUrl(URL.createObjectURL(response));
    },
    onError: () => alert.show({ type: 'error', message: 'Erro ao carregar foto de perfil' }),
    enabled: !!pictureId,
    refetchOnWindowFocus: true,
    retryDelay: 10000,
  });
  useEffect(() => {
    if (isFeedPicture && pictureProfile?.url) {
      setPictureUrl(pictureProfile.url);
    }
  }, [isFeedPicture, pictureProfile]);
  return (
    <Container>
      <img src={pictureUrl || userIcon} alt="Foto de perfil" />
    </Container>
  );
}
